import { prefersReducedMotion,useLoopInView } from "@/4-components/animations/anime";
import { WfBar, WfColumn, WfLegend,WfLift, WFN, WFN_NET } from "@/4-components/composites/waterfall";

import { BentoArt, bentoLoop } from "./BentoArt";

/**
 * Riduzione prevedibile, the bridge of `NetCostBars`, in the tile that leads to it.
 * Same four columns: la bolletta di oggi (costo energia + costo GO), il controvalore GO
 * che si sottrae, la quota dei ricavi dell'energia venduta, il costo netto. On loop the columns
 * build left→right, hold, then recede. No labels and no equation, those belong on the page.
 */
export function NetCostMini() {
  const ref = useLoopInView<HTMLDivElement>((root) => {
    const bars = ["nm-energy", "nm-go", "nm-ghost", "nm-prof", "nm-net"].map((c) => root.querySelector<HTMLElement>(`.${c}`));
    if (bars.some((b) => !b)) return;
    const [energy, go, ghost, prof, net] = bars as HTMLElement[];

    if (prefersReducedMotion()) {
      // the punchline, held still: la bolletta sta in piedi, le due sottrazioni sono fatte, resta il netto
      for (const b of [energy, go, prof, net]) b.style.transform = "scaleY(1)";
      go.style.opacity = "0.35";
      ghost.style.opacity = "1";
      return;
    }

    const tl = bentoLoop()
      // 01, la bolletta di oggi
      .add(energy, { scaleY: [0, 1], duration: 650, ease: "outQuart" }, 300)
      .add(go, { scaleY: [0, 1], duration: 500, ease: "outQuart" }, 850)
      // 02, il controvalore GO si sottrae: il fantasma compare, il cappello si smorza
      .add(ghost, { opacity: [0, 1], duration: 550 }, 1500)
      .add(go, { opacity: [1, 0.35], duration: 550 }, 1500)
      // 03, e la quota dei ricavi dell'energia venduta
      .add(prof, { scaleY: [0, 1], duration: 550, ease: "outQuart" }, 2200)
      // 04, il costo netto
      .add(net, { scaleY: [0, 1], duration: 800, ease: "outQuart" }, 2900)
      // hold on the result, then unwind so the loop restart doesn't snap
      .add(net, { scaleY: [1, 0], duration: 600 }, 5500)
      .add(prof, { scaleY: [1, 0], duration: 500 }, 5700)
      .add(ghost, { opacity: [1, 0], duration: 450 }, 5900)
      .add(go, { opacity: [0.35, 1], duration: 450 }, 5900)
      .add(go, { scaleY: [1, 0], duration: 450 }, 6200)
      .add(energy, { scaleY: [1, 0], duration: 600 }, 6400);

    return tl;
  });

  return (
    <BentoArt ref={ref} className="flex h-full flex-col justify-end">
      <div className="layout-waterfall-mini">
        <WfColumn>
          <WfBar cls="nm-go" h={WFN.go} className="rounded-md bg-dec-green" />
          <WfBar cls="nm-energy" h={WFN.energy} className="rounded-md bg-zinc-200" />
        </WfColumn>
        <WfColumn>
          <WfBar cls="nm-ghost" h={WFN.go} mode="fade" className="rounded-md border-2 border-dashed border-dec-green/60" />
          <WfLift h={WFN.energy} />
        </WfColumn>
        <WfColumn>
          <WfBar cls="nm-prof" h={WFN.prof} className="rounded-md bg-dec-green/25 ring-1 ring-inset ring-dec-green/35" />
          <WfLift h={WFN_NET} />
        </WfColumn>
        <WfColumn>
          <WfBar cls="nm-net" h={WFN_NET} className="rounded-md bg-dec-green" />
        </WfColumn>
      </div>
      <WfLegend />
    </BentoArt>
  );
}
